"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixStackrelBraces = fixStackrelBraces;
const tex_syntax_1 = require("./tex-syntax");
const stackrelWithUnbracedFirstArg = new RegExp(`(\\\\stackrel)(\\?|\\s*\\\\${tex_syntax_1.color}${(0, tex_syntax_1.block)(1)})`, "g");
const stackrelWithUnbracedSecondArg = new RegExp(`(\\\\stackrel${(0, tex_syntax_1.block)(2)})\\s*(\\\\(blueE|purpleD|ce|text)\\s*(${(0, tex_syntax_1.block)(1)}| \\w))`, "g");
const stackrelWithHydrogenAsSecondArg = new RegExp(`(\\\\stackrel${(0, tex_syntax_1.block)(2)})(H)`, "g");
function fixStackrelBraces(tex) {
    return (tex
        // First, put braces around the first argument of stackrel if they're
        // missing.
        .replace(stackrelWithUnbracedFirstArg, "$1{$2}")
        // Next, put braces around the second argument if they're missing.
        .replace(stackrelWithUnbracedSecondArg, "$1{$2}")
        // Fix a rare case where stackrel is used in a chemistry expression
        .replace(stackrelWithHydrogenAsSecondArg, "$1{\\vphantom H}\\!\\!\\!\\!\\!$2")
        // Fix a rare case where stackrel is used to put a checkmark over an
        // equals sign
        .replace(/\\stackrel\\checkmark=/g, "\\stackrel{\\checkmark}{=}"));
}
